import { LoadingButton } from "@mui/lab";
import {
    Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  IconButton,
  Modal,
  Skeleton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { doc, getDoc } from "firebase/firestore";
import TimeAgo from "javascript-time-ago";
import classess from "../EmployeeDashboardComponent/EmployeeDashboardComponent.module.css";
import en from "javascript-time-ago/locale/en.json";
import ru from "javascript-time-ago/locale/ru.json";
import React, { useEffect, useState } from "react";
import ReplayIcon from "@mui/icons-material/Replay";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { db } from "../../firebase/firebaseConfig";
import {
  acceptInvite,
  acceptInviteCandidateTeam,
  initMessage,
  offerActions,
  rejectInvite,
  rejectInviteCandidateTeam,
} from "../../firebase/functions";
import {
  flexCenter,
  responsiveFlexDirection,
} from "../../utilities/commonStyles/commonStyles";
import MessageButton from "../../MessageButton/MessageButton";
import LoadingSearchComponents from "../SharedComponents/LoadingSearchComponents/LoadingSearchComponents";
import { CandidatedProfileMessageIcon, EmployeeDashboardComponentSeeTracedIcon } from "../../utilities/Icons/Icons";
import { useForm } from "react-hook-form";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
function OfferCandidate({ data, item, flag , setflag }) {
    const [open, setOpen] = React.useState(false);
    const [loadingAssign, setLoadingAssign] = React.useState(false);
    const [status , setStatus] = useState("")
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  TimeAgo.addDefaultLocale(en);
    TimeAgo.addLocale(ru);
     const [avatar, setAvatar] = useState("");
     const [loadingError, setLoadingError] = useState(false);
  const [offerStatus, setOfferStatus] = useState(false);
    const [invitestatus, setInvitestatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingAbout, setLoadingAbout] = useState(false);
  const [inviteLoad, setInviteLoad] = useState(false);
    const {
      register,
      handleSubmit,
      setValue,
      formState: { errors },
      reset,
    } = useForm();
    const onSubmit = (tempData) => {
        setLoadingAssign(true);
    if (status == "accept") {
      acceptInviteCandidateTeam({
        ...tempData,
        jobId: data.jobId,
        candidateId: data.candidateId,
      })
        .then((data) => {
          console.log(data.data);
          if (data.data == "insufficient-data") {
            toast.error("Incomplete Profile");
            setflag(flag + 1);
            setLoadingAssign(false);
          } else {
            toast.success("Candidate Accepted");
            setInvitestatus("invitationAccepted");
              setLoadingAssign(false);
              setOpen(false);
              setflag(flag + 1);
          }
        })
        .catch((e) => {
          console.log(e.message);
        });
    } else {
      rejectInviteCandidateTeam({
        ...tempData,
        jobId: data.jobId,
        candidateId: data.candidateId,
      }).then(() => {
        toast.success("Candidate Rejected");
        setInvitestatus("invitationRejected");
        setLoadingAssign(false);
        setOpen(false);
        setflag(flag + 1);
      });
    }
    };
  useEffect(() => {
    setOfferStatus(item?.offerStatus);
    setInvitestatus(item?.status);
    console.log(data);
      soln();
  }, [data]);
     const soln = async () => {
       const usercollectionRef = doc(db, `Users/${data?.candidateId}`);
       const docSnap = await getDoc(usercollectionRef);
       if (docSnap.exists()) {
         console.log("Document data:", docSnap.data());
         // setAboutUsData(docSnap.data().about);
         console.log(docSnap.data());
         setAvatar(docSnap.data().displayImage);
         setLoading(false);
         setLoadingError(false);
       } else {
         //! doc.data() will be undefined in this case
         // console.log(error);
         setLoading(false);
         setLoadingError(true);
       }
     };
  return (
    <>
      {loading ? (
        <Skeleton variant="rect" width="100%" height={170} />
      ) : loadingError ? (
        <Container sx={{ my: "30px" }}>
          <Box
            sx={{
              ...flexCenter,
              flexDirection: "column",
              gap: "20px",
              textAlign: "center",
            }}
          >
            <Box>
              <Typography
                sx={{
                  color: "#B7B7B7",
                  fontSize: "25px",
                  fontFamily: "Poppins",
                }}
              >
                Sorry ! something went wrong.
              </Typography>
            </Box>
            <ReplayIcon
              onClick={() => {
                setflag(flag + 1);
              }}
              sx={{
                width: "5vw",
                height: "5vw",
                color: "#B7B7B7",
                cursor: "pointer",
              }}
            />
          </Box>
        </Container>
      ) : (
        <Box
          sx={{
            ...responsiveFlexDirection,
            width: "100%",
            display: "flex",
            border: "1px solid #e0e0e0",
            maxHeight: "100%",
            marginTop: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            backgroundColor: { xs: "#24BD2C", md: "transparent" },
          }}
        >
          {/* avatar */}
          <Box
            sx={{
              display: "flex",
              width: { xs: "100%", md: "60%" },
              padding: { xs: "10px", md: "20px" },
              gap: "10px",
              backgroundColor: { md: "#24BD2C" },
              color: "#FFF",
            }}
          >
            <Box
              sx={{
                width: { xs: "45px", md: "90px" },
                height: { xs: "45px", md: "90px" },
              }}
            >
              <Avatar
                sx={{ width: "100%", height: "100%" }}
                src={avatar}
                alt=""
              />
            </Box>
            {/* candidate details */}
            <Box
              sx={{
                width: "100%",
                height: "100%",
                gap: "10px",
              }}
            >
              <Typography
                sx={{ fontWeight: "500", fontSize: "18px", lineHeight: "18px" }}
              >
                {data?.firstName} {data?.lastName}
              </Typography>
              <Typography
                className="text_field-span"
                sx={{ marginTop: "10px", marginBottom: "10px" }}
              >
                <Stack
                  direction
                  alignItems={"center"}
                  gap={1}
                  sx={{
                    color: "#FFF",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "14px",
                  }}
                >
                  <span>
                    <svg
                      width="13"
                      height="16"
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.5 0C4.77672 0.00196598 3.1246 0.66484 1.90606 1.84321C0.687511 3.02159 0.00203992 4.61924 6.91533e-06 6.28571C-0.00205706 7.64756 0.457949 8.97245 1.30946 10.0571C1.30946 10.0571 1.48673 10.2829 1.51569 10.3154L6.5 16L11.4867 10.3126C11.5127 10.2823 11.6905 10.0571 11.6905 10.0571L11.6911 10.0554C12.5422 8.97121 13.002 7.64693 13 6.28571C12.998 4.61924 12.3125 3.02159 11.0939 1.84321C9.8754 0.66484 8.22328 0.00196598 6.5 0ZM6.5 8.57143C6.03252 8.57143 5.57553 8.43737 5.18684 8.18622C4.79814 7.93506 4.49518 7.57808 4.31629 7.16042C4.13739 6.74276 4.09058 6.28318 4.18178 5.83979C4.27298 5.39641 4.4981 4.98913 4.82866 4.66947C5.15922 4.34981 5.58038 4.13211 6.03888 4.04392C6.49738 3.95572 6.97263 4.00099 7.40452 4.17399C7.83642 4.34699 8.20557 4.63996 8.46529 5.01584C8.72501 5.39172 8.86363 5.83364 8.86363 6.28571C8.86285 6.89169 8.61358 7.47263 8.17048 7.90112C7.72738 8.32961 7.12663 8.57067 6.5 8.57143Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  {"  "} {data?.state},{data?.city}{" "}
                  {data?.noticePeriod ? (
                    <>
                      {" "}
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.32201 0.0169382C6.98808 0.144689 5.99595 0.426818 4.8727 0.997793C3.54212 1.67411 2.34813 2.74361 1.47753 4.03888C1.10891 4.58731 0.658457 5.51315 0.442172 6.16689C0.267594 6.69457 0.128918 7.29509 0.0441635 7.8904C-0.0147212 8.30408 -0.0147212 9.69267 0.0441635 10.1063C0.191639 11.1424 0.465648 12.0499 0.893749 12.9202C1.3781 13.9049 1.85252 14.5664 2.63576 15.3492C3.41044 16.1233 4.08271 16.6067 5.03109 17.0717C5.69283 17.3961 6.12009 17.554 6.79094 17.7221C8.55129 18.1634 10.3168 18.0788 12.0367 17.4707C12.558 17.2865 13.4681 16.8307 13.9359 16.5195C14.9878 15.8201 15.9534 14.8309 16.6425 13.7468C16.896 13.348 17.3034 12.5065 17.4696 12.0385C18.2965 9.71012 18.1525 7.21106 17.0659 5.02751C16.6273 4.1463 16.1391 3.45566 15.4536 2.74681C14.6934 1.96067 13.9478 1.41829 12.9504 0.925792C11.9079 0.411025 10.9364 0.136247 9.78269 0.0297062C9.4241 -0.00339226 8.6089 -0.0105325 8.32201 0.0169382ZM9.34076 3.8367C9.42322 3.88028 9.54053 3.98471 9.60149 4.06878L9.7123 4.22164L9.7218 6.63635L9.73134 9.05107L11.5726 10.8977C13.151 12.4807 13.4198 12.7651 13.455 12.8892C13.5178 13.1111 13.5046 13.2584 13.4037 13.4609C13.2459 13.7773 12.9147 13.931 12.5649 13.85C12.3927 13.8102 12.3267 13.7486 10.3872 11.817C9.26688 10.7011 8.3571 9.76699 8.31878 9.6932C8.25246 9.56555 8.25063 9.47741 8.25978 6.89108L8.26922 4.22076L8.37481 4.07096C8.58803 3.76846 9.0155 3.66481 9.34076 3.8367Z"
                          fill="#25C027"
                        />
                      </svg>
                      {"  "} 1 month notice period{" "}
                    </>
                  ) : null}
                </Stack>
              </Typography>
              <Typography
                sx={{
                  marginTop: "9px",
                  marginBottom: "9px",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "14px",
                }}
              >
                Experience:{" "}
                <span
                  style={{
                    color: "#FFF",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "14px",
                  }}
                >
                  {data?.experience} Years
                </span>{" "}
              </Typography>
              <Typography
                sx={{
                  marginTop: "9px",
                  marginBottom: "9px",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "14px",
                }}
              >
                Job Preference:{" "}
                <span
                  style={{
                    color: "#FFF",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "14px",
                  }}
                >
                  {data?.jobPreference}
                </span>{" "}
              </Typography>
              <Stack direction gap={1}>
                <Stack direction gap={1}>
                  {data?.skills
                    ? data?.skills.map((skill, index) => {
                        return (
                          <Chip
                            sx={{ color: "gray", backgroundColor: "#f0faf0" }}
                            label={skill}
                          />
                        );
                      })
                    : data?.skills?.map((skill) => {
                        return (
                          <Chip
                            sx={{ color: "gray", backgroundColor: "#f0faf0" }}
                            label={skill}
                          />
                        );
                      })}
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Box
            sx={{
              ...flexCenter,
              width: { xs: "100%", md: "40%" },
              minHeight: "100%",
              border: { md: "1px solid #25C027" },
              borderRadius: { md: "0px 20px 20px 0px" },
              display: "flex",
              flexDirection: { xs: "row", md: "column" },
              flexWrap: { xs: "wrap", md: "nowrap" },
              mt: { xs: "10px", md: "0px" },
            }}
          >
            <Stack
              direction
              alignItems={"center"}
              gap={1}
              sx={{ ...flexCenter }}
            >
              <LoadingButton
                onClick={(e) => {
                  e.stopPropagation();
                  setLoadingAbout(true);
                  initMessage({ candidateId: data.id }).then(({ data }) => {
                    console.log("MEEEESAGWE", data);
                    setLoadingAbout(false);
                    navigate("/employee-dashboard/message");
                    //   toast.success(data);
                  });
                }}
                loading={loadingAbout}
                // startIcon={<MessageIcon />}
                loadingIndicator={<CircularProgress />}
              >
                {/* {applicantId} */}
                <Box
                  sx={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "6px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: { xs: "#FFF", md: "#25C027" },
                    fill: { md: "#FFF", xs: "#25C027" },
                  }}
                >
                  <CandidatedProfileMessageIcon />
                </Box>
              </LoadingButton>
              <Box
                sx={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: { xs: "#FFF", md: "#EAF9EA" },
                }}
              >
                <Tooltip placement="top" arrow title="View profile">
                  <IconButton
                    onClick={() => {
                        navigate(`/employee-dashboard/recruiter/${data.candidateId}/${data.jobId}`);
                    }}
                  >
                    <EmployeeDashboardComponentSeeTracedIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              {data?.status == "Pending" ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "30px",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    marginTop: "15px",
                  }}
                >
                  <LoadingButton
                    loadingIndicator={<CircularProgress size={20} />}
                    loading={inviteLoad}
                    onClick={() => {
                      setStatus("accept");
                      setOpen(true);
                    }}
                    sx={{
                      width: "125px",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#fff",
                      backgroundColor: "#25c027",
                      borderRadius: "3px",
                      "&:hover": {
                        backgroundColor: "success.dark",
                      },
                    }}
                  >
                    Accept
                  </LoadingButton>
                  <LoadingButton
                    loadingIndicator={<CircularProgress size={20} />}
                    loading={inviteLoad}
                    // color="error.main"
                    onClick={() => {
                      setStatus("reject");
                      setOpen(true);
                    }}
                    sx={{
                      width: "125px",
                      height: "100%",
                      display: "flex",
                      color: "#fff",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "red",
                      borderRadius: "3px",
                      marginLeft: "5px",
                      "&:hover": {
                        backgroundColor: "error.dark",
                      },
                    }}
                  >
                    Reject
                  </LoadingButton>
                </Box>
              ) : (
                <></>
              )}{" "}
              {data?.status == "Accepted" ? (
                <Chip
                  style={{
                    color: "black",
                    backgroundColor: "#e9f9e9",
                    borderRadius: "0px",
                    marginBottom: "10px",
                  }}
                  label={
                    <Stack alignItems={"center"} direction gap={1}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 100 128"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M2.76848 0.375582C1.60183 0.896414 0.506469 2.18272 0.235875 3.34976C-0.078978 4.70657 -0.0784482 117.221 0.236405 118.578C0.531646 119.85 1.91748 121.321 3.1586 121.678C3.7679 121.854 11.5038 121.921 25.3611 121.87L46.6282 121.792L45.077 119.721C42.312 116.028 40.2713 111.566 39.1756 106.817C38.4174 103.531 38.2348 97.3796 38.7943 93.9747C41.1194 79.8291 52.0271 69.0241 66.9386 66.0963C70.2968 65.4369 76.1627 65.4814 79.4941 66.1918C84.3202 67.221 88.8098 69.2823 92.7298 72.2692C93.7518 73.0479 94.6505 73.6851 94.7268 73.6851C94.8032 73.6851 94.8657 64.501 94.8657 53.2759V32.8667H80.2128H65.56L64.3928 32.2704C63.7511 31.9422 62.9804 31.3374 62.6804 30.9257C62.1469 30.1942 62.1332 29.8427 62.0621 15.0887L61.9895 0L32.7765 0.010337C8.95953 0.0188187 3.41674 0.0864077 2.76848 0.375582ZM70.4831 13.5178V24.385H81.4142H92.3455L81.4818 13.5178C75.5067 7.5408 70.5878 2.65054 70.5507 2.65054C70.5136 2.65054 70.4831 7.5408 70.4831 13.5178ZM68.2715 72.235C59.3061 73.9321 51.2977 79.8553 47.4615 87.6264C45.4891 91.6221 44.6887 94.9915 44.6975 99.2628C44.7105 105.539 46.6709 111.23 50.5485 116.248C54.5698 121.451 59.5616 124.874 65.4479 126.464C67.3425 126.976 68.3531 127.073 71.8083 127.072C74.7297 127.071 76.4139 126.946 77.6389 126.637C87.3535 124.193 94.9492 117.781 98.4261 109.089C99.7056 105.891 100.014 104.07 99.9996 99.7929C99.9884 96.3722 99.8901 95.4553 99.2948 93.2257C98.5528 90.4463 96.8788 86.6627 95.2972 84.1897C93.9209 82.038 90.1543 78.2165 87.8189 76.6018C85.2258 74.8089 81.9575 73.2968 79.2007 72.6145C76.2324 71.8798 71.0906 71.7014 68.2715 72.235ZM84.2646 88.9384C86.397 90.0151 87.2676 92.6802 86.1081 94.582C85.0793 96.2698 73.9142 109.484 73.0968 109.981C71.7693 110.788 70.6313 110.885 69.3562 110.3C68.0981 109.722 60.3477 103.181 59.8754 102.299C59.4784 101.557 59.4884 99.6066 59.8931 98.8228C60.76 97.144 62.193 96.2139 63.9104 96.216C65.2168 96.2176 65.7397 96.5137 68.4461 98.7844L70.4034 100.426L74.7501 95.2091C77.1406 92.3396 79.3838 89.7206 79.7353 89.389C80.8807 88.3081 82.6649 88.1306 84.2646 88.9384Z"
                          fill="#25C027"
                        />
                      </svg>
                      Invitation Accepted
                    </Stack>
                  }
                />
              ) : null}
              {data?.status == "Rejected" ? (
                <Chip
                  style={{
                    color: "black",
                    backgroundColor: "#fbeae9",
                    borderRadius: "0px",
                    marginBottom: "10px",
                  }}
                  label={
                    <Stack alignItems={"center"} direction gap={1}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M30.2295 0.278672C28.577 0.691875 27.34 1.39748 26.0939 2.63787C24.8106 3.91553 24.0348 5.32242 23.6774 7.02053C23.5262 7.7381 23.4585 13.2643 23.4585 24.8736V41.6872L25.418 41.6086C29.5546 41.4425 34.3245 42.296 38.4605 43.9421C42.5629 45.5749 46.3022 48.0855 49.5967 51.4192L51.4965 53.3418H67.7093C83.5711 53.3418 83.939 53.3505 84.6968 53.7366C85.5676 54.1806 86.2618 55.3104 86.2618 56.2835C86.2618 57.2566 85.5676 58.3864 84.6968 58.8304C83.9416 59.2153 83.5669 59.2251 69.6097 59.2251H55.297L56.0365 60.9411C57.2997 63.8716 58.1789 67.0456 58.5118 69.8747L58.6431 70.9917H71.2828C83.5632 70.9917 83.9443 71.0029 84.6968 71.3865C85.5676 71.8305 86.2618 72.9603 86.2618 73.9334C86.2618 74.9065 85.5676 76.0362 84.6968 76.4802C83.9443 76.8638 83.5632 76.875 71.2932 76.875H58.6643L58.4119 78.6563C57.2883 86.5893 52.5777 94.68 46.3427 99.3862L44.9887 100.408H68.4614C84.9833 100.408 92.242 100.343 92.9741 100.189C96.3046 99.4884 99.086 96.7097 99.7822 93.3876C99.9368 92.6499 100 82.6524 100 58.9214V25.4943H88.3983H76.7966L76.0137 25.0546C75.5542 24.7965 75.0769 24.3137 74.8585 23.8858C74.5054 23.1941 74.4862 22.5595 74.4862 11.5783V0L52.8485 0.0166693C36.2294 0.0294165 30.9832 0.0902105 30.2295 0.278672ZM80.374 10.688V19.611H89.3521H98.3302L89.402 10.688C84.4915 5.78033 80.4513 1.76499 80.4238 1.76499C80.3964 1.76499 80.374 5.78033 80.374 10.688ZM84.6968 36.0867C85.5676 36.5307 86.2618 37.6605 86.2618 38.6336C86.2618 39.6067 85.5676 40.7365 84.6968 41.1805C83.9341 41.5692 83.5844 41.5753 61.7147 41.5753H39.5071L38.7242 41.1356C36.7491 40.0264 36.7291 37.342 38.687 36.1577L39.4537 35.6939L61.6881 35.6929C83.5856 35.692 83.9339 35.6978 84.6968 36.0867ZM23.6548 47.5788C17.3388 48.3557 12.0493 50.933 7.65763 55.3735C3.75735 59.3171 1.5086 63.5264 0.361658 69.0306C-0.120553 71.3437 -0.120553 76.523 0.361658 78.8361C1.50978 84.3462 3.76481 88.5643 7.65763 92.4842C11.6103 96.4642 15.93 98.7959 21.4959 99.9542C23.7833 100.43 28.9628 100.43 31.3562 99.9532C36.6525 98.8989 41.0407 96.5505 44.9765 92.6638C48.9294 88.7604 51.2835 84.4005 52.4432 78.8361C52.9254 76.5232 52.9254 71.3437 52.4432 69.0306C51.6892 65.4124 50.2914 62.0473 48.2888 59.029C47.0531 57.1668 43.219 53.3222 41.4001 52.1214C38.2365 50.0331 34.8257 48.5991 31.4622 47.9437C29.8806 47.6354 25.0355 47.4089 23.6548 47.5788ZM18.8072 62.4804C19.1526 62.6527 21.0027 64.3507 22.9188 66.2533L26.4024 69.7129L29.8861 66.2533C31.8019 64.3507 33.6523 62.6527 33.9977 62.4804C36.3942 61.2841 39.0614 63.9492 37.8642 66.3439C37.6917 66.6891 35.9925 68.538 34.0884 70.4524L30.6262 73.9334L34.0884 77.4143C35.9925 79.3287 37.6917 81.1777 37.8642 81.5228C39.0614 83.9175 36.3942 86.5826 33.9977 85.3864C33.6523 85.214 31.8019 83.5161 29.8861 81.6134L26.4024 78.1538L22.9188 81.6134C21.0027 83.5161 19.1526 85.214 18.8072 85.3864C16.4106 86.5826 13.7435 83.9175 14.9406 81.5228C15.1132 81.1777 16.8124 79.3287 18.7165 77.4143L22.1787 73.9334L18.7165 70.4524C16.8124 68.538 15.1132 66.6891 14.9406 66.3439C13.7431 63.9484 16.4099 61.2837 18.8072 62.4804Z"
                          fill="#D93025"
                        />
                      </svg>
                      Invitation Rejected
                    </Stack>
                  }
                />
              ) : null}
            </Stack>
          </Box>
        </Box>
      )}
      <Modal
        open={false}
        // onClose={}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Stack
          border={5}
          sx={{
            width: "100%",
            height: "100vh",
          }}
          justifyContent={"center"}
          alignItems="center"
        >
          <LoadingSearchComponents />
        </Stack>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={classess.hidescrollbar}
          sx={{
            ...style,
            width: { xs: "95%", md: "50%" },
            overflow: "scroll",
            height: "50%",
          }}
          component={"form"}
          noValidate
          onSubmit={handleSubmit(onSubmit)}
        >
          <Stack spacing={4}>
            <Box>
              <Typography
                sx={{
                  color: "#25C027",
                  fontFamily: "Sofia Pro",
                  fontSize: "30px",
                  fontWeight: 500,
                }}
              >
                Send Response
              </Typography>
            </Box>
            <TextField
              id="outlined-basic"
              label="Note"
              variant="outlined"
              color="success"
              multiline
              {...register("orgNote", { required: "Note is required" })}
              rows={5}
              sx={{
                width: "100%",
                mt: "10px",
                color: "#696969",
                fontFamily: "Sofia Pro",
                fontSize: "15px",
              }}
              error={Boolean(errors.orgNote)}
              helperText={errors.orgNote && errors.orgNote.message}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <LoadingButton
                loading={loadingAssign}
                sx={{
                  textTransform: "none",
                  fontSize: "15px",
                  fontFamily: "",
                  backgroundColor: "#25C027",
                  color: "#fff",
                  padding: "14px 50px",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#25C027",
                  },
                }}
                type="submit"
              >
                Send
              </LoadingButton>
            </Box>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

export default OfferCandidate;
